export default __webpack_public_path__ + "static/media/factory__17.acb1c0cf.jpg";